import { motion, useReducedMotion } from "motion/react";
import { Icon } from "@project/ui";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";

export function LoadingState(): JSX.Element {
  const { t } = useI18n();
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      className="flex min-h-[12rem] flex-col items-center justify-center gap-3 rounded-xl bg-surface-container-low px-6 py-12 text-center"
      role="status"
      aria-live="polite"
      initial={prefersReducedMotion ? undefined : { opacity: 0, y: 6 }}
      animate={prefersReducedMotion ? undefined : { opacity: 1, y: 0 }}
      transition={prefersReducedMotion ? undefined : { duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
    >
      <Icon name="LoaderCircle" className="size-8 animate-spin text-primary" strokeWidth={1.5} />
      <p className="font-body text-body-md text-on-surface-variant">{t("common.loading")}</p>
      <p className="text-label-md text-on-surface-variant/80">{t("dashboardUi.states.loadingHint")}</p>
    </motion.div>
  );
}
